import { App } from "./core/App.js";
// Importing the PWA module here registers the beforeinstallprompt listener
// immediately at module-eval time, before window.onload, so we don't miss
// the event when the browser fires it early.
import { registerServiceWorker, persistStorage } from "./data/pwa.js";
import { initAudio, preloadSfx, playSfx, SFX_BUTTON, SFX_PREMIUM_BUTTON } from "./data/audio.js";

window.onload = function()
{
    const container = document.getElementById( 'app' );

    // Prevent LittleJS document-level touch handlers from calling
    // preventDefault(), which blocks click synthesis on mobile.
    container.addEventListener( 'touchstart', e => e.stopPropagation() );
    container.addEventListener( 'touchend',   e => e.stopPropagation() );

    const app = new App( container );
    app.run();

    registerServiceWorker();
    persistStorage();
    initAudio();
    preloadSfx();

    // Global button-press SFX on pointerdown — fires before any click handler
    // and before any navigation/DOM teardown those handlers may trigger
    // (e.g. router.redirect on the Start button), so SFX never gets stranded
    // mid-bubble. Capture phase beats any nested stopPropagation. Primary
    // button only (button === 0) so right/middle clicks stay silent.
    // playSfx() calls Howler.ctx.resume() itself — pointerdown counts as a
    // user gesture for autoplay-policy purposes.
    document.addEventListener( 'pointerdown', ( e ) =>
    {
        if ( e.button !== undefined && e.button !== 0 ) return;
        const btn = e.target && e.target.closest && e.target.closest( 'button' );
        if ( !btn || btn.disabled ) return;
        // Buttons that spend coins opt in via data-sfx="premium" and get a
        // distinct rising-beep cue instead of the standard click.
        const isPremium = btn.dataset && btn.dataset.sfx === 'premium';
        playSfx( isPremium ? SFX_PREMIUM_BUTTON : SFX_BUTTON );
    }, true );
};
